import { FM } from './config.js';
import { initHTML } from './init-bootstrap-html.js';
import { getLocale } from './locale.js';

import { entries as manifestDesktop } from '/dist/app/module/desktop/manifest.json';

/*global top, self, window, document, location, setTimeout */
const doc = document;
const win = window;
const loc = location;

if (top !== self) {
    // Frame buster.
    top.location.replace(loc);
} else if (!PRODUCTION) {
    doc.documentElement.classList.add('is-desktop');
    initHTML();
    win.DESKTOP = true;
    win.FM = FM;
    FM.version = '';
    FM.manifest = {};
    FM.preload = () => {};
    FM.import = (x) => x();
    const sessions = FM.sessions;
    const userId = FM.userId;
    const session =
        sessions && userId && sessions.find((x) => x.userId === userId);
    const language = session && session.language;
    if (language) {
        // handled by rollup-plugin-lang-import
        import(/* @vite-ignore */ `/app/locale/${language}.js`);
    } else {
        import('/app/locale/en-gb.js');
    }
} else if (loc.protocol === 'https:' || POBOX) {
    const manifest = manifestDesktop;
    const pathToModules = `/app/module/desktop/`;
    const relativePathToModules = '..' + pathToModules;
    const absolutePathToModules = FM.pathToDist + pathToModules;
    const preloadModule = (name) => {
        const link = doc.createElement('link');
        link.rel = 'modulepreload';
        link.href = absolutePathToModules + name;
        doc.head.appendChild(link);
        setTimeout(() => doc.head.removeChild(link), 0);
    };
    const _import = (x, name, timeout) => {
        const module = manifest[name];
        if (module) {
            module.dependencies.forEach(preloadModule);
        }
        return x().catch(
            () =>
                new Promise((resolve) => {
                    if (document.visibilityState === 'visible') {
                        timeout = timeout ? Math.max(2 * timeout, 30000) : 1000;
                        setTimeout(() => {
                            resolve(_import(x, '', timeout));
                        }, timeout);
                    } else {
                        document.addEventListener(
                            'visibilitychange',
                            function retry() {
                                document.removeEventListener(
                                    'visibilitychange',
                                    retry,
                                );
                                resolve(_import(x, ''));
                            },
                        );
                    }
                }),
        );
    };
    const preloadModuleAndDependencies = (name) => {
        const module = manifest[name];
        if (module) {
            module.dependencies.forEach(preloadModule);
            preloadModule(module.file);
        }
    };

    FM.manifest = manifest;
    FM.preload = preloadModuleAndDependencies;
    FM.import = _import;

    win.FastMail = FM; // For the app
    win.FM = FM;

    initHTML();

    const language = getLocale(manifest, FM.sessions, FM.userId);
    const loadLangModule = () =>
        import(/* @vite-ignore */ relativePathToModules + language);

    // Array#findLast is the most recent feature we use; anything that has it
    // will have the other things from ES6+ that we need, so we don’t need to
    // add the weight and load time of core-js for them. Browsers that thus
    // need core-js are approximately: Edge≤96, Firefox≤103, Chrome≤96,
    // Safari≤15.3 (15.4 has it), Opera≤82
    if (!Array.prototype.findLast) {
        _import(() => import('./core-js-modern.js')).then(() =>
            _import(loadLangModule),
        );
        preloadModule(language);
    } else {
        _import(loadLangModule);
    }
    preloadModuleAndDependencies('main');
}
